import { usePlannerPermissions } from "@/permissions/usePlannerPermissions";
import type { PermissionActions, PermissionSubjects } from "@/types";
import { type Ref } from "vue";
import { useRouter } from "vue-router";

type PermissionChecker = Ref<boolean>;

export function useCan() {
  const router = useRouter();

  const PERMISSION_MAP: Record<
    PermissionSubjects,
    Partial<Record<PermissionActions, PermissionChecker>>
  > = {
    planner: usePlannerPermissions(),
  };

  const can = (
    action: PermissionActions,
    subject: PermissionSubjects,
  ): Ref<boolean> => {
    const checker = PERMISSION_MAP[subject][action];

    if (checker !== undefined) {
      return checker;
    }

    throw new Error(`Undefined permission check: ${action}@${subject}`);
  };

  const shouldHave = (
    action: PermissionActions,
    subject: PermissionSubjects,
  ) => {
    if (can(action, subject).value === false) {
      router.push("/");
    }
  };

  return {
    can,
    shouldHave,
  };
}
